<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.slider_show") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #3eb6d4">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <!-- <base-image-upload-input col="12" identifier="image" :placeholder="$t('PLACEHOLDERS.image')"
             /> -->
          <!-- End:: Image Upload Input -->
          <p class="text-center">{{ $t("PLACEHOLDERS.media") }}</p>
          <UploadMedia
            :disabled="true"
            :for_id="'ad_images'"
            :content="$t('PLACEHOLDERS.media')"
            ref="ad_images"
            accept="image/*,video/*"
          />

          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ad_name_ar')"
            v-model.trim="data.nameAr"
            disabled
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ad_name_en')"
            v-model.trim="data.nameEn"
            disabled
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.start_date')"
            v-model.trim="data.publish_start_date"
            disabled
            required
          />

          <base-picker-input
            col="6"
            type="date"
            :placeholder="$t('PLACEHOLDERS.end_date')"
            v-model.trim="data.publish_end_date"
            disabled
            required
          />
          <base-select-input
            col="6"
            :optionsList="url_types"
            :placeholder="$t('PLACEHOLDERS.url_type')"
            v-model="data.url_type"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.external_link')"
            v-model.trim="data.external_link"
            v-if="data.url_type?.value === 'external_link'"
            required
            disabled
          />
          <!-- End:: Name Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";
import UploadMedia from "../../../components/formInputs/UploadMedia.vue";

export default {
  name: "CreateAds",
  components: { BaseImageUploadInput, UploadMedia },
  computed: {
    url_types() {
      return [
        {
          id: 0,
          name: this.$t("PLACEHOLDERS.external_link"),
          value: "external_link",
        },
      ];
    },
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      file: null,
      fileType: "",
      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          type: null,
        

},

        nameAr: null,
        nameEn: null,
        active: true,
        publish_start_date: null,
        publish_end_date: null,
        media: null,
        media_type: null,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    // start all ads data
    async getAdsData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `advertisements/${this.$route.params.id}`,
        });
        this.data.nameAr = res.data.data.data?.name_ar;
        this.data.nameEn = res.data.data.data?.name_en;
        this?.$refs?.ad_images.setFiles([
          {
            id: "id",
            url: res.data.data.data?.file,
          },
        ]);
        this.data.publish_start_date = res.data.data.data?.start_date;
        this.data.publish_end_date = res.data.data.data?.end_date;
        this.data.url_type = this.url_types.find(
          (type) => type.value === res.data.data.data?.url_type
        );
        this.data.external_link = res.data.data.data?.url;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end all ads data
  },

  created() {
    // Start:: Fire Methods
    this.getAdsData();
    // End:: Fire Methods
  },
};
</script>

<style>
.preview-container img,
.preview-container video {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 20px;
}
</style>
